export const LIGHTBOX_IDLE = 'concrete/LIGHTBOX_IDLE'
export const LIGHTBOX_MEDIA_TYPE = 'concrete/LIGHTBOX_MEDIA_TYPE'



// WEBPACK FOOTER //
// ./src/components/lightbox-container/action-types.js